import React from "react";
import AdminReports from "../../../components/admin/reports/admin-reports";
import AdminTemplate from "../../../templates/admin-template";

const AdminReportsPage = () => {
  return (
    <AdminTemplate>
      <AdminReports />
    </AdminTemplate>
  );
};

export default AdminReportsPage;
